import { render, staticRenderFns } from "./TablaUsuariosGrupo.vue?vue&type=template&id=d0bcff40&"
import script from "./TablaUsuariosGrupo.vue?vue&type=script&lang=js&"
export * from "./TablaUsuariosGrupo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports